import UseQuery from "@/shared/hooks/use-query.hook";
import { debounce } from "lodash";
import React, { useEffect } from "react";

function LoadReview() {
  const { getQuery } = UseQuery();

  const loadReview = debounce(() => {
    setTimeout(() => {
      const btn = document.getElementById("id-rating-modal");
      btn?.click();
    }, 4500);
  }, 500);

  useEffect(() => {
    const { isNewProperty } = getQuery();
    if (isNewProperty) {
      loadReview();
    }
    return () => {
      loadReview.cancel();
    };
  }, []);
  return <></>;
}

export default LoadReview;
